module.exports = __webpack_public_path__ + "img/09 Animation 2-squashed.63f5dc53.jpg";